
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smart-tv-advertising",
      function () {
        return require("private-next-pages/smart-tv-advertising/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smart-tv-advertising"])
      });
    }
  